/*
 * This file is generated by icons/template.js
 */
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { COMMON, CommonProps } from '../constants';
import theme from '../theme';
import sizeStyle, { IconSizeProps } from '../lib/iconSize';

const SvgComponent = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" viewBox="0 0 512 512" {...props}>
    <path
      d="M512 256c0 18.328-1.927 36.206-5.598 53.451-12.463 58.684-45.025 109.925-90.134 146.188l-.014-.015h-.001l.015.015C372.396 490.901 316.666 512 256 512c-97.491 0-182.252-54.49-225.491-134.681l.001-.001h-.001C11.042 341.212 0 299.9 0 256c0-42.45 10.324-82.482 28.624-117.731C71.23 56.124 157.061 0 256 0c62.115 0 119.068 22.126 163.404 58.937l-82.933 67.895C313.136 112.246 285.552 103.82 256 103.82c-66.729 0-123.429 42.957-143.965 102.724l-.002-.001.001.001c-5.317 15.502-8.215 32.142-8.215 49.456.002 18.792 3.406 36.798 9.651 53.408v.002-.001c21.619 57.698 77.278 98.772 142.53 98.772 28.047 0 54.323-7.582 76.87-20.819l.002.002v-.002c29.932-17.553 53.324-45.025 65.646-77.911h-136.89V208.177h245.899C510.467 223.662 512 239.655 512 256"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);

type Props = CommonProps & IconSizeProps;
const IconGoogle = styled(SvgComponent)<Props>`
  ${sizeStyle}
  ${COMMON}
`;
IconGoogle.defaultProps = {
  theme,
};
IconGoogle.propTypes = { ...sizeStyle.propTypes, ...COMMON.propTypes, theme: PropTypes.object };
IconGoogle.displayName = 'IconGoogle';
export { IconGoogle };
